<template>
  <div class="oc-signature-settings" :class="{ 'oc-signature-settings--embedded': embedded }">
    <p v-if="!embedded" class="text-muted small mb-75">
      Choose where the company stamp appears in the PDF. Default is first page and after
      Terms &amp; Conditions. Last page is optional and is not added unless you check it.
    </p>
    <p v-else class="text-muted small mb-75 mb-0">
      Default stamp: first page and after Terms &amp; Conditions. Employee Name /
      Signature lines stay off unless you enable them here.
    </p>

    <b-form-group
      label="Company stamp / signature image"
      :label-for="`${idPrefix}-sig-placement`"
      class="mb-75"
    >
      <b-form-checkbox-group
        :id="`${idPrefix}-sig-placement`"
        :checked="signatureLocations"
        :options="signatureOptions"
        stacked
        :disabled="disabled"
        @input="onSignatureLocationsInput"
      />
    </b-form-group>

    <b-form-group label="Employee acceptance lines" class="mb-0">
      <b-form-checkbox
        :checked="employeeSign.withStamp"
        :disabled="disabled"
        class="mb-25"
        @input="onEmployeeSignInput('withStamp', $event)"
      >
        Show employee lines next to company stamp
      </b-form-checkbox>
      <b-form-checkbox
        :checked="employeeSign.showName"
        :disabled="disabled"
        class="mb-25"
        @input="onEmployeeSignInput('showName', $event)"
      >
        Show &quot;Employee Name&quot; line
      </b-form-checkbox>
      <b-form-checkbox
        :checked="employeeSign.showSignature"
        :disabled="disabled"
        class="mb-50"
        @input="onEmployeeSignInput('showSignature', $event)"
      >
        Show &quot;Employee Signature&quot; line
      </b-form-checkbox>
      <label class="small font-weight-bold d-block mb-25">Layout of employee lines</label>
      <b-form-radio-group
        :checked="employeeSign.layout"
        :options="layoutOptions"
        :disabled="disabled"
        @input="onEmployeeSignInput('layout', $event)"
      />
    </b-form-group>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormRadioGroup,
} from 'bootstrap-vue'
import {
  OFFER_SIGNATURE_PLACEMENT_OPTIONS,
  OFFER_EMPLOYEE_SIGN_LAYOUT_OPTIONS,
} from '@/utils/offer-template-editor'

export default {
  name: 'OfferSignatureSettings',
  components: {
    BFormGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormRadioGroup,
  },
  props: {
    idPrefix: {
      type: String,
      default: 'oc-sig',
    },
    signatureLocations: {
      type: Array,
      default: () => [],
    },
    employeeSign: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      signatureOptions: OFFER_SIGNATURE_PLACEMENT_OPTIONS,
      layoutOptions: OFFER_EMPLOYEE_SIGN_LAYOUT_OPTIONS,
    }
  },
  methods: {
    onSignatureLocationsInput(value) {
      this.$emit('signature-locations-change', value)
    },
    onEmployeeSignInput(prop, value) {
      this.$emit('employee-sign-change', prop, value)
    },
  },
}
</script>

<style scoped>
.oc-signature-settings {
  background: #fafbff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 0.35rem;
  padding: 0.75rem;
}

.oc-signature-settings--embedded {
  background: transparent;
  border: 0;
  padding: 0;
}
</style>
